import * as yup from 'yup';
import { error } from './text';

const requiredValidation = yup.string().required(error.required);

const imageValidation = yup
  .mixed<File>()
  .test('fileFormat', error.image, value => {
    if (value instanceof File) {
      const supportedFormats = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'svg'];
      const fileExtension = value.name.split('.').pop()?.toLowerCase();
      return supportedFormats.includes(fileExtension || '');
    }
    return true;
  })
  .test('fileSize', error.imageSize, value => {
    if (value instanceof File) {
      return value.size <= 10 * 1024 * 1024; // 10MB以下
    }
    return true;
  });

const hasLetterAndNumberAndSymbol = /(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!-/:-@[-`{-~])/;
const hasLetterAndNumber = /(?=.*[a-zA-Z])(?=.*[0-9])/;
const hasLetterAndSymbol = /(?=.*[a-zA-Z])(?=.*[!-/:-@[-`{-~])/;
const hasNumberAndSymbol = /(?=.*[0-9])(?=.*[!-/:-@[-`{-~])/;
const combinedRegex = new RegExp(
  `${hasLetterAndNumberAndSymbol.source}|` +
    `${hasLetterAndNumber.source}|` +
    `${hasLetterAndSymbol.source}|` +
    `${hasNumberAndSymbol.source}`,
);

export const telValidation = yup
  .string()
  .matches(/^[0-9-]*$/, error.tel)
  .max(20, error.below20)
  .required(error.required);

export const passwordValidataion = yup
  .string()
  .required(error.required)
  .min(6, error.min)
  .matches(combinedRegex, error.mixed)
  .max(250, error.below250);

export const passwordConfirmValidation = yup
  .string()
  .required(error.required)
  .test('passwordMatch', error.passwordMatch, function (value) {
    if (value && value !== this.resolve(yup.ref('password'))) {
      return false;
    }
    return true;
  });

export const AuthRegisterSchema = yup.object().shape({
  company: requiredValidation.max(50, error.below50),
  department: requiredValidation.max(250, error.below250),
  email: yup.string().nullable(),
  name: requiredValidation.max(250, error.below250),
  tel: telValidation,
  password: passwordValidataion,
  passwordConfirm: passwordConfirmValidation,
  agreeToTerms: yup.boolean().oneOf([true], error.agreeToTerms).required(error.agreeToTerms),
});

/**
 * 企業招待からの会員登録（#3071）
 * 部署名・電話番号を任意にする。入力された場合の文字数・形式のチェックは維持する。
 * サービスサイトからの自己登録（AuthRegisterSchema）は従来どおり必須のままとする。
 */
export const CompanyInviteRegisterSchema = yup.object().shape({
  company: requiredValidation.max(50, error.below50),
  // 未入力を許容しつつ、フォームの型（string）に合わせるため既定値を空文字にする
  department: yup.string().max(250, error.below250).default(''),
  email: yup.string().nullable(),
  name: requiredValidation.max(250, error.below250),
  tel: yup
    .string()
    .matches(/^[0-9-]*$/, error.tel)
    .max(20, error.below20)
    .default(''),
  password: passwordValidataion,
  passwordConfirm: passwordConfirmValidation,
  agreeToTerms: yup.boolean().oneOf([true], error.agreeToTerms).required(error.agreeToTerms),
});

export const StaffRegisterSchema = yup.object().shape({
  // 企業招待と揃えて部署名は任意入力とする（#3071）
  // 未入力を許容しつつ、フォームの型（string）に合わせるため既定値を空文字にする
  department: yup.string().max(250, error.below250).default(''),
  icon: imageValidation,
  email: yup.string().nullable(),
  name: requiredValidation.max(250, error.below250),
  password: passwordValidataion,
  passwordConfirm: passwordConfirmValidation,
  agreeToTerms: yup.boolean().oneOf([true], error.agreeToTerms).required(error.agreeToTerms),
});

export const clientStaffEditSchema = yup.object().shape({
  // 企業招待では部署名を任意で登録できるため、編集時も任意とする（#3071）
  // 未入力を許容しつつ、フォームの型（string）に合わせるため既定値を空文字にする
  department: yup.string().max(250, error.below250).default(''),
  iconId: yup.string().nullable(),
  icon: imageValidation,
  email: yup.string().nullable(),
  name: requiredValidation.max(250, error.below250),
  role: yup.bool().oneOf([true, false], error.required).required(error.required),
});
